var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "p-10" },
    [
      _c("div", { staticClass: "disp-flex" }, [
        _c("div", [
          _c(
            "h1",
            { staticStyle: { display: "inline-block" } },
            [
              _vm.recipient && _vm.recipient.name
                ? [
                    _vm._v(
                      "\n\t\t\t\t\t" +
                        _vm._s(_vm.recipient.name) +
                        " (" +
                        _vm._s(_vm.recipient.account_id) +
                        ")\n\t\t\t\t"
                    )
                  ]
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _vm.recipient
            ? _c(
                "div",
                { staticStyle: { display: "inline-block" } },
                [
                  _vm._l(_vm.recipient.tags, function(tag, index) {
                    return _c(
                      "el-tag",
                      {
                        key: index,
                        staticClass: "recipient-tag",
                        attrs: {
                          size: "mini",
                          type: "info",
                          effect: "dark",
                          closable: tag.can_remove
                        },
                        on: {
                          close: function($event) {
                            return _vm.handleTagRemove(tag.tag, tag.tag_name)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t" +
                            _vm._s(_vm.$translate.tag(tag.tag_name)) +
                            "\n\t\t\t\t"
                        )
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _vm.customTags && _vm.customTags.length > 0
                    ? [
                        _vm.showTagSelect
                          ? _c(
                              "el-select",
                              {
                                ref: "selectTag",
                                attrs: { size: "mini" },
                                on: { change: _vm.handleAddTagAdd }
                              },
                              _vm._l(_vm.customTags, function(customTag) {
                                return _c("el-option", {
                                  key: customTag.reference,
                                  attrs: {
                                    label: _vm.$t(customTag.tag),
                                    value: customTag.reference
                                  }
                                })
                              }),
                              1
                            )
                          : _c(
                              "el-button",
                              {
                                attrs: { size: "mini" },
                                on: { click: _vm.handleAddTagClick }
                              },
                              [
                                _c("i", { staticClass: "el-icon-plus" }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("recipient_detail.add_tag"))
                                )
                              ]
                            )
                      ]
                    : _vm._e()
                ],
                2
              )
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c(
            "el-tabs",
            {
              on: { "tab-click": _vm.handleTabClick },
              model: {
                value: _vm.activeTab,
                callback: function($$v) {
                  _vm.activeTab = $$v
                },
                expression: "activeTab"
              }
            },
            [
              _c("el-tab-pane", {
                attrs: {
                  label: _vm.$t("recipientDetail.detail"),
                  name: "DETAIL"
                }
              }),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    name: "MESSAGES",
                    disabled: !_vm.hasMessagesPermission
                  }
                },
                [
                  _c(
                    "span",
                    { attrs: { slot: "label" }, slot: "label" },
                    [
                      !_vm.hasMessagesPermission
                        ? [_c("i", { staticClass: "el-icon-lock" })]
                        : _vm._e(),
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(_vm.$t("recipientDetail.messages")) +
                          "\n\t\t\t\t\t"
                      ),
                      _vm.recipient?.message_recipients?.length > 0
                        ? _c("el-badge", {
                            attrs: {
                              value: _vm.recipient?.message_recipients?.length
                            }
                          })
                        : _vm._e()
                    ],
                    2
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    name: "ARCHIVE",
                    disabled: !_vm.hasMessagesPermission
                  }
                },
                [
                  _c(
                    "span",
                    { attrs: { slot: "label" }, slot: "label" },
                    [
                      !_vm.hasMessagesPermission
                        ? [_c("i", { staticClass: "el-icon-lock" })]
                        : _vm._e(),
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(_vm.$t("recipientDetail.archive")) +
                          "\n\t\t\t\t"
                      )
                    ],
                    2
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.recipient && _vm.recipient.name
        ? _c(
            "el-row",
            { attrs: { gutter: 5 } },
            [
              _c(
                "el-col",
                [
                  _c(
                    "el-card",
                    { staticClass: "mb-15" },
                    [_c("messages-table")],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }